import { createAction } from 'redux-actions'

import * as CONSTANTS from './constants'

export const createError = createAction<Error>(CONSTANTS.APP_ERROR)
export const cleanErrors = createAction(CONSTANTS.APP_ERROR_CLEAN)
